import { render } from "./Reward.vue?vue&type=template&id=226fbf52"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"

import "./Reward.vue?vue&type=style&index=0&id=226fbf52&lang=less"

import exportComponent from "/Users/wanglei/lnmp/www/study-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__